import { Request } from '../utils/request';
import { HttpHeaders } from '../utils/types/headers.types';
import { ReturnMethod } from '../components/about-page/HowToUseRA';

export interface APIKeys {
    prod: string;
    test: string;
}

/* eslint-disable camelcase */

/* API Data Structure */
export interface APIUserInfo {
    partner_id: string;
    product_ids: string[];
    partner_name: string;
    partner_email: string;
    partner_website: string;
    partner_platform: string;
    stripe_account_status: boolean;
    admin_domain_encoded: string;
}

export interface APIAboutPageConfigs {
    merchant_name: string;
    use_label: boolean;
    policy: string;
    link: string;
}

export interface NewAPIAboutPageConfigsData {
    data: NewAPIAboutPageConfigs;
}

export interface NewAPIAboutPageConfigs {
    returnToSeel: boolean;
    shopDomain: string;
    returnWindow: string;
}

/* Normalized Data */

export type PartnerFinancialAccount = {
    accountId: string;
    platform: string;
    status: boolean;
};

export interface UserInfo {
    partnerId: string;
    partnerName: string;
    email: string;
    website: string;
    partnerPlatform: string;
    stripeAccountConnected: boolean;
    adminDomainEncoded: string;
}

export interface AboutPageConfigs {
    name: string;
    returnMethod: ReturnMethod;
    policy: string;
    link: string;
}

export interface NewAboutPageConfigs {
    returnToSeel: boolean;
    shopDomain: string;
    returnWindow: string;
}

export class PartnerUserService {
    public static async getUserInfo(token: string | undefined): Promise<UserInfo> {
        const response = await Request.get<APIUserInfo>('/v1/frontend/get_partner_info', {
            headers: {
                [HttpHeaders.XAccessToken]: token || '',
            },
        });
        const {
            partner_id,
            partner_email,
            partner_name,
            partner_website,
            stripe_account_status,
            partner_platform,
            admin_domain_encoded,
        } = response.data;
        console.log(response.data);
        return {
            partnerId: partner_id,
            partnerName: partner_name,
            email: partner_email,
            website: partner_website,
            partnerPlatform: partner_platform,
            stripeAccountConnected: stripe_account_status,
            adminDomainEncoded: admin_domain_encoded,
        };
    }

    public static async getAboutPageConfigs(domain: string): Promise<AboutPageConfigs> {
        const response = await Request.get<APIAboutPageConfigs>(
            '/v1/frontend/get_about_page_configs',
            {
                params: { shop_domain: domain },
            }
        );

        const { merchant_name, use_label, policy, link } = response.data;

        return {
            name: merchant_name,
            returnMethod: use_label ? ReturnMethod.Label : ReturnMethod.Merchant,
            policy,
            link,
        };
    }

    public static async getNewAboutPageConfigs(domain: string): Promise<NewAboutPageConfigs> {
        const response = await Request.get<NewAPIAboutPageConfigsData>(
            '/gateway/merchant-service/api/about-page-config',
            {
                params: { admin_domain: domain },
            }
        );

        const { returnToSeel, shopDomain, returnWindow } = response.data.data;

        return {
            returnToSeel,
            shopDomain,
            returnWindow,
        };
    }
}
